/** #@condition: betSharing **/
/** Only if betSharing feature is enabled **/
import MojitoServices from 'mojito/services';

import {mergeTo} from '#core/utils/config-utils.js';
import {SpriteMapStorage} from '#core/utils/spritemap-storage/index.js';
import {getCSSFromFontsArray} from '#core/utils/embedding-utils.js';

import {ApplicationConfig} from '#core/config/application-config.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {Dialogs} from '../dialogs.js';

import {betSharingDialogFactory} from './bet-sharing.factory.js';

import SCHEMA from './bet-sharing.schema.yaml';
import PALETTE_SCHEMA from './bet-sharing.palette-schema.yaml';

class BetSharingFeature extends AbstractVisualFeature {
    get name() {
        return 'BetSharing';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return betSharingDialogFactory(PALETTE);
    }

    updateViewsConfig(viewsConfig) {
        mergeTo(viewsConfig, {
            ShareBet: {
                maximumNumberOfSelections: this.config.maximumNumberOfSelectionsToShare,
            },
            ShareDialog: {
                imageOptions: {
                    cacheBust: true,
                    skipFonts: true,
                    fontEmbedCSS: getCSSFromFontsArray(ApplicationConfig.config.fonts),
                    filter: node => {
                        const {spritePrefix, spriteIdToSpriteHTMLNodeMap} = SpriteMapStorage;

                        if (node instanceof SVGSVGElement) {
                            const spriteUseName = node.querySelector('use')?.getAttribute('href');
                            const spriteName = spriteUseName.replace(`#${spritePrefix}`, '');
                            const spriteNode = spriteIdToSpriteHTMLNodeMap[spriteName];

                            if (!spriteNode) return false;

                            node.setAttribute('viewBox', spriteNode.getAttribute('viewBox'));
                            node.innerHTML = spriteNode.innerHTML;
                        }

                        return true;
                    },
                },
            },
        });
    }

    updateMojitoConfig(mojitoConfig) {
        mojitoConfig.services.sharingService = {service: MojitoServices.Sharing.service};

        super.updateMojitoConfig(mojitoConfig);
    }
}

if (FEATURES.betSharing) {
    new BetSharingFeature(Dialogs);
}
